import { LoginService } from './../../../core/services/login.service';
import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
const getSupplyReviewCountQuery = gql`query get_supply_review_count($supply_id:uuid!, $supply_variant_id:uuid!, $user_id: uuid!){
  supply_reviews_aggregate(where: {
    supply_id: {_eq: $supply_id},
    supply_variant_id: {_eq: $supply_variant_id},
    _or: [{
      dental_practice_id:{_eq: $user_id}
    },{
      dental_professional_id:{_eq: $user_id}
    }, {
      dental_supplier_id:{_eq: $user_id }
    }]
  }){
    aggregate{
      count
    }
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetReviewCheckService {

  constructor(
    private apollo: Apollo,
    private loginService: LoginService) { }

  getSupplyReviewCount(supply_id: string, supply_variant_id: string){
    return this.apollo.use('external').query({
      query: getSupplyReviewCountQuery,
      variables: {
        supply_id,
        supply_variant_id,
        user_id: this.loginService.getLoginData().id
      }
    }).pipe(pluck('data', 'aggregate', 'count'));
  }
}
